import { FC, SVGProps } from 'react'
import { useNavigate } from 'react-router';

import {ReactComponent as LogoSvg} from './logo.svg'

export const Logo: FC<SVGProps<SVGSVGElement>> = (props) => {
    const navigate = useNavigate()

    return <LogoSvg {...props} className={["cursor-pointer", props.className].asClass} onClick={props.onClick || (() => navigate('/'))} />
};